module.exports = __webpack_public_path__ + "img/tsum.197d5e4a.jpg";